import React from "react";
import { TbPlusMinus } from "react-icons/tb";


export const WinLossReasonsIcon = (props) => {
    return (
        <div style={{minWidth: "1.75em"}}>
            <TbPlusMinus 
                size="1.15em"
                color={props.color ? props.color : undefined}
            />
        </div>
    );
};